module.exports = __webpack_public_path__ + "img/weddings_06_V.69551f10.jpg";